module.exports = __webpack_public_path__ + "static/media/WhitespaceBadOptimized.92e7dbee.webp";